import React, {createContext, useContext} from 'react';
import './RulesSectionLink.css';

// Якоря внутри разделов правил, на которые можно сослаться из другого раздела
export const RULES_ANCHOR_IDS = {
  FLYING_UNITS: 'rules-flying-units',
};

/**
 * Переход к другому разделу правил: (sectionId, anchorId?) => void. Дает
 * RulesModal; вне модалки (серверный рендер правил для MCP-агентов, тесты)
 * контекста нет, и ссылка остается просто выделенным текстом
 */
export const RulesNavigationContext = createContext(null);

/**
 * Ссылка из одного раздела правил на другой (и на место в нем — anchorId).
 * Общие правила, которые касаются нескольких фракций (например, полет),
 * описаны один раз в своем разделе, а правила фракций на них ссылаются
 *
 * @param {string} sectionId — RULES_SECTION_IDS
 * @param {string} [anchorId] — RULES_ANCHOR_IDS
 */
const RulesSectionLink = ({sectionId, anchorId, children}) => {
  const navigate = useContext(RulesNavigationContext);

  if (!navigate) {
    return <b>{children}</b>;
  }

  return (
    <button
      type={'button'}
      className={'rules-section-link'}
      onClick={() => navigate(sectionId, anchorId)}
    >
      {children}
    </button>
  );
};

export default RulesSectionLink;
